export const LIBRARY_PREVIEW_FULL_REPORT_LABEL = "Allow full report in library request preview";
export const LIBRARY_PREVIEW_FULL_REPORT_SETTINGS_LABEL =
  "Library Request Review - Allow for VQA Report Preview";

export function previewFullReportPayload(allow) {
  return { allow_full_report_preview: Boolean(allow) };
}

export function canShowLibraryPreviewFullReportMenuItem({
  isAdmin,
  isVqa,
  isOrgVendorLibrary,
  documentId,
} = {}) {
  return Boolean(isAdmin && isVqa && isOrgVendorLibrary && documentId);
}

export function libraryPreviewFullReportMenuLabel(enabled) {
  return enabled ? "Use observation report in preview" : LIBRARY_PREVIEW_FULL_REPORT_LABEL;
}
